import {MarginProps} from 'styled-system'
import styled from '@emotion/styled'

import {Flex} from './Box'

interface SpinnerProps {
  size: 'small' | 'medium' | 'large'
}

const LOADING_SIZES = {
  small: 30,
  medium: 50,
  large: 100,
} as const

const BORDER_SIZES = {
  small: 5,
  medium: 6,
  large: 10,
} as const

const loadingSize = ({size}: SpinnerProps) => LOADING_SIZES[size]
const loadingBorderSize = ({size}: SpinnerProps) => BORDER_SIZES[size]

export const LoadingSpinner = styled.div<SpinnerProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${loadingSize}px;
  height: ${loadingSize}px;
  &:after {
    content: '';
    display: block;
    width: ${(props) => loadingSize(props) * 0.6}px;
    height: ${(props) => loadingSize(props) * 0.6}px;
    border-radius: 50%;
    border: ${loadingBorderSize}px solid ${(props) => props.theme.colors.grey5};
    border-color: ${(props) => props.theme.colors.grey5} transparent
      ${(props) => props.theme.colors.grey5} transparent;
    animation: lds-dual-ring 1.2s linear infinite;
  }

  @keyframes lds-dual-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

interface Props extends SpinnerProps, MarginProps {}

const Loading = ({size, ...props}: Props) => (
  <Flex justifyContent="center" alignItems="center" {...props}>
    <LoadingSpinner size={size} />
  </Flex>
)

export const AppearAfter = styled.div<{appearAfter: string}>`
  animation: ${(props) => props.appearAfter} appear linear forwards;
  visibility: hidden;
  @keyframes appear {
    99% {
      visibility: hidden;
    }
    100% {
      visibility: visible;
    }
  }
`

export default Loading

interface LoadingContentPlaceholderProps extends MarginProps, SpinnerProps {
  appearAfter?: string
}
export const LoadingContentPlaceholder = ({
  appearAfter = '1s',
  ...props
}: LoadingContentPlaceholderProps) => (
  <AppearAfter appearAfter={appearAfter}>
    <Loading {...props} />
  </AppearAfter>
)
